import { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AnalysisRouter = () => {
    const navigate = useNavigate();
    const { tcid } = useSelector((state) => state.tc);

    useEffect(() => {
        if (tcid !== null && tcid !== undefined) {
            navigate(`/analysis/${tcid}`);
        } else {
            navigate("/upload");
        }
    }, [navigate, tcid]);

    return (
        <h1>Routing...</h1>
    );
}

export default AnalysisRouter;